import util from '../util'

let controller = 'OperadorOnboardingAssociadoSubparceiro'
export default Object.assign({}, util.GetCrud(controller, null), {
})
